/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewDeliveryConfig
 */
export interface NewDeliveryConfig {
    /**
     * 
     * @type {Array<number>}
     * @memberof NewDeliveryConfig
     */
    supportedParishes?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof NewDeliveryConfig
     */
    excludedTowns?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof NewDeliveryConfig
     */
    knutsfordActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NewDeliveryConfig
     */
    zipMailActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NewDeliveryConfig
     */
    inHouseActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NewDeliveryConfig
     */
    courierId?: number;
}

/**
 * Check if a given object implements the NewDeliveryConfig interface.
 */
export function instanceOfNewDeliveryConfig(value: object): value is NewDeliveryConfig {
    return true;
}

export function NewDeliveryConfigFromJSON(json: any): NewDeliveryConfig {
    return NewDeliveryConfigFromJSONTyped(json, false);
}

export function NewDeliveryConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewDeliveryConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'supportedParishes': json['supportedParishes'] == null ? undefined : json['supportedParishes'],
        'excludedTowns': json['excludedTowns'] == null ? undefined : json['excludedTowns'],
        'knutsfordActive': json['knutsfordActive'] == null ? undefined : json['knutsfordActive'],
        'zipMailActive': json['zipMailActive'] == null ? undefined : json['zipMailActive'],
        'inHouseActive': json['inHouseActive'] == null ? undefined : json['inHouseActive'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function NewDeliveryConfigToJSON(json: any): NewDeliveryConfig {
    return NewDeliveryConfigToJSONTyped(json, false);
}

export function NewDeliveryConfigToJSONTyped(value?: NewDeliveryConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'supportedParishes': value['supportedParishes'],
        'excludedTowns': value['excludedTowns'],
        'knutsfordActive': value['knutsfordActive'],
        'zipMailActive': value['zipMailActive'],
        'inHouseActive': value['inHouseActive'],
        'courierId': value['courierId'],
    };
}

